import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCfCertifyCertifySm = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	x: "0px",
	y: "0px",
	viewBox: "0 0 100 100",
	style: { enableBackground: "new 0 0 100 100" },
	xmlSpace: "preserve",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M72.3,73v7.2L68.1,76l-0.3-0.3c-0.1-0.1-0.3-0.2-0.4-0.2c-0.2,0-0.3,0.1-0.4,0.2l-3.1,3.1l-1.4,1.4v-0.7v-1.4 V73c1.5,0.7,3.2,1.1,5,1.1c0.3,0,0.7,0,1,0c0.8-0.1,1.5-0.2,2.2-0.4C71.2,73.5,71.8,73.3,72.3,73z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M77.5,62.1c0,0.2,0,0.4,0,0.7c0,3.3-1.6,6.2-4,8c-0.3,0.3-0.7,0.5-1.1,0.7c-0.1,0-0.1,0.1-0.2,0.1 c-0.7,0.4-1.5,0.8-2.4,1c-0.8,0.2-1.7,0.3-2.6,0.3c-1.8,0-3.5-0.5-5-1.3c-0.4-0.2-0.9-0.5-1.2-0.8c-1.5-1.2-2.7-2.8-3.4-4.6 c-0.1-0.4-0.3-0.8-0.4-1.2c-0.2-0.7-0.2-1.4-0.2-2.2c0-4.2,2.6-7.9,6.3-9.4c0.4-0.2,0.8-0.3,1.2-0.4c0.8-0.2,1.7-0.3,2.6-0.3 c4.4,0,8.2,2.8,9.6,6.7C77.2,60.2,77.4,61.1,77.5,62.1z M73.3,60.4c0.3-0.3,0.3-0.8,0-1.2c-0.3-0.3-0.9-0.3-1.2,0l-6.9,6.9 l-2.5-2.5c-0.3-0.3-0.8-0.3-1.2,0c-0.3,0.3-0.3,0.9,0,1.2l3.1,3.1c0.2,0.2,0.4,0.2,0.6,0.2s0.4-0.1,0.6-0.2L73.3,60.4z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-white",
			d: "M63.5,46.6V52c-4.4,1.6-7.6,5.8-7.6,10.8c0,1,0.1,1.9,0.4,2.8l-5.6,3.2V54L63.5,46.6z"
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-white",
			points: "62.9,45.5 50,52.9 37.1,45.4 50,38  "
		}),
		/* @__PURE__ */ _jsx("polygon", {
			className: "icon-white",
			points: "49.4,54 49.4,68.8 36.5,61.3 36.5,46.5  "
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-highlight",
			d: "M73.7,58.9L73.7,58.9c-0.5-0.5-1.4-0.5-1.9,0l-6.6,6.6l-2.1-2.1c-0.5-0.5-1.4-0.5-1.9,0 c-0.5,0.5-0.5,1.4,0,1.9l3.1,3.1c0.2,0.3,0.6,0.4,0.9,0.4c0.4,0,0.7-0.1,0.9-0.4l7.5-7.5C74.2,60.2,74.2,59.4,73.7,58.9z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "icon-outline",
			d: "M79.3,53.6c0-16.1-13.1-29.3-29.3-29.3c-16.1,0-29.3,13.1-29.3,29.3c0,16.1,13.1,29.3,29.3,29.3 c3.7,0,7.2-0.7,10.6-2v0.9c0,0.5,0.3,0.9,0.7,1c0.4,0.2,0.9,0.1,1.2-0.2l4.8-4.8l4.8,4.8c0.2,0.2,0.5,0.3,0.8,0.3 c0.2,0,0.3,0,0.4-0.1c0.4-0.2,0.7-0.6,0.7-1v-9.2c3.3-2.2,5.2-5.9,5.2-9.8c0-1.2-0.2-2.4-0.5-3.5C79.1,57.3,79.3,55.5,79.3,53.6z  M62.9,73.8c1.4,0.6,2.9,0.9,4.5,0.9c0.4,0,0.7,0,1,0c0.8-0.1,1.6-0.2,2.3-0.4c0.4-0.1,0.7-0.2,1.1-0.4V79l-3.7-3.7 c-0.4-0.4-1.2-0.4-1.6,0L62.9,79V73.8z M72.2,71.1c0,0-0.1,0.1-0.2,0.1c-0.7,0.4-1.5,0.7-2.3,0.9c-2.4,0.6-5,0.3-7.2-0.9 c-0.4-0.2-0.8-0.5-1.2-0.8c-1.5-1.1-2.6-2.7-3.2-4.4c-0.1-0.4-0.3-0.8-0.3-1.2c-0.1-0.7-0.2-1.4-0.2-2.1c0-3.9,2.4-7.5,6-9 c0.4-0.2,0.8-0.3,1.2-0.4c0.8-0.2,1.6-0.3,2.5-0.3c4.1,0,7.7,2.6,9.1,6.4c0.3,0.9,0.5,1.7,0.5,2.6c0,0.2,0,0.4,0,0.6 c0,3-1.4,5.8-3.8,7.6C72.9,70.6,72.6,70.9,72.2,71.1z M50,26.6c14.9,0,27,12.1,27,27c0,0.7,0,1.4-0.1,2.1c-2.2-3-5.8-4.9-9.6-4.9 c-0.7,0-1.4,0.1-2.1,0.2v-5.5c0-0.4-0.2-0.8-0.6-1l-14.2-8.2c-0.3-0.2-0.8-0.2-1.1,0l-14.1,8.1c-0.3,0.2-0.6,0.6-0.6,1v16.3 c0,0.4,0.2,0.8,0.6,1l14.2,8.2c0.4,0.2,0.8,0.2,1.1,0l5.8-3.4c0.9,2,2.4,3.8,4.2,5.1v5.9c-3.4,1.5-6.9,2.2-10.6,2.2 c-14.9,0-27-12.1-27-27C23,38.7,35.1,26.6,50,26.6z M48.9,54.3v13.7L37,61V47.4L48.9,54.3z M61.9,45.5L50,52.3l-11.9-6.9L50,38.6 L61.9,45.5z M55.7,65.3l-4.5,2.6V54.3L63,47.4v4.2c-4.5,1.8-7.6,6.2-7.6,11.1C55.4,63.6,55.5,64.5,55.7,65.3z"
		})
	] })
});
export default SvgCfCertifyCertifySm;
